<template>
  <div class="class">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {}
  },
  methods: {
    
  }
}
</script>

<style lang="scss" scoped>
.class {
  height: calc(100% - 50px);
  padding: 10px;
  // background-color: #eee;
  margin-top: 10px;
  box-shadow:#eee 0px 0px 10px
}
</style>
